/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integration_OfflineInputs */

const en_integration_offline = /** @type {(inputs: Integration_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to the internet to manage this integration.`)
};

const es_integration_offline = /** @type {(inputs: Integration_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conéctate a internet para gestionar esta integración.`)
};

/**
* | output |
* | --- |
* | "Connect to the internet to manage this integration." |
*
* @param {Integration_OfflineInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const integration_offline = /** @type {((inputs?: Integration_OfflineInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_OfflineInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_integration_offline(inputs)
	return en_integration_offline(inputs)
});